const secretKey = new TextEncoder().encode(
  process.env.REACT_APP_STORE_SECRET_KEY
);

const macSecKey = new TextEncoder().encode(
  process.env.REACT_APP_STORE_MAC_SECRET_KEY
);

//convert the charCode to string
function charCodeToString(data) {
  return btoa(String.fromCharCode.apply(null, data));
}

//convert the string into an charCode
function stringToCharCode(data) {
  return new Uint8Array(Array.from(atob(data), (c) => c.charCodeAt(0)));
}

//restructure the string encrypted data to an Object for decryption
function encryptedObject(encryptedStringData) {
  return {
    iv: stringToCharCode(encryptedStringData.substring(0, 24)),
    mac: stringToCharCode(encryptedStringData.substring(24, 68)),
    data: stringToCharCode(
      encryptedStringData.substring(68, encryptedStringData.length)
    ),
  };
}

// Encrypt data using the secret key
export async function encryptText(data) {
  try {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data);

    const iv = crypto.getRandomValues(new Uint8Array(16)); // Initialization Vector

    const algo = {
      name: "AES-GCM",
      iv: iv,
    };

    // Generate a random MAC key (replace with your actual MAC key)
    // const macKey = crypto.getRandomValues(new Uint8Array(32)); // HMAC-SHA-256 key

    const macKey = await crypto.subtle.importKey(
      "raw",
      // encoder.encode(macSecKey),
      macSecKey,
      { name: "HMAC", hash: { name: "SHA-256" } },
      false,
      ["sign"]
    );
    // console.log("enc mackey val------", macKey);
    const encryptionKey = await crypto.subtle.importKey(
      "raw",
      secretKey,
      "AES-GCM",
      false,
      ["encrypt"]
    );

    const ciphertext = await crypto.subtle.encrypt(
      algo,
      encryptionKey,
      encodedData
    );

    // Calculate the MAC for the ciphertext using HMAC
    const macAlgo = {
      name: "HMAC",
      hash: { name: "SHA-256" },
    };

    const mac = await crypto.subtle.sign(macAlgo, macKey, ciphertext);
    // console.log("encryption data------", {
    //   iv: iv,
    //   data: new Uint8Array(ciphertext),
    //   mac: new Uint8Array(mac),
    // });

    let ivStrVal = charCodeToString(iv);
    let macStrVal = charCodeToString(new Uint8Array(mac));
    let dataStrVal = charCodeToString(new Uint8Array(ciphertext));
    return `${ivStrVal}${macStrVal}${dataStrVal}`;

    // return {
    //   iv: iv,
    //   data: new Uint8Array(ciphertext),
    //   mac: new Uint8Array(mac),
    // };
  } catch (error) {
    console.error("Error while encrypting data:", error);
  }
}

// Decrypt data using the secret key
export async function decryptText(encryptedStringData) {
  try {
    const { iv, mac, data } = encryptedObject(encryptedStringData);
    const algo = {
      name: "AES-GCM",
      iv: iv,
    };

    const encryptionKey = await crypto?.subtle?.importKey(
      "raw",
      secretKey,
      "AES-GCM",
      false,
      ["decrypt"]
    );

    // Verify the MAC using HMAC-SHA-256
    const macAlgo = {
      name: "HMAC",
      hash: { name: "SHA-256" },
    };

    // Replace `yourMacKey` with your actual secret MAC key
    const macKeyVal = await crypto?.subtle?.importKey(
      "raw",
      macSecKey,
      macAlgo,
      false,
      ["verify"]
    );
    // console.log("macKey val-------", macKeyVal);

    // Verify the MAC for the received data
    const isValidMAC = await crypto?.subtle?.verify(
      macAlgo,
      macKeyVal,
      mac,
      data
    );
    // console.log("isValidMAC-------", isValidMAC);
    if (isValidMAC) {
      const decryptedData = await crypto?.subtle?.decrypt(
        algo,
        encryptionKey,
        data
      );
      const decoder = new TextDecoder();
      return decoder.decode(decryptedData);
    } else {
      console.error(
        "MAC verification failed. Data may have been tampered with."
      );
      return null;
    }
  } catch (error) {
    console.error("Error while decrypting data:", error);
    return null;
  }
}

function isUint8Array(obj) {
  return obj instanceof Uint8Array;
}
